import { render, staticRenderFns } from "./validatedBpi.vue?vue&type=template&id=1f552b57&"
import script from "./validatedBpi.vue?vue&type=script&lang=js&"
export * from "./validatedBpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports